import React from 'react';
import styles from '../Operations.module.css';

interface ARW2Component extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * ACTIVECUSTCOUNT - Active Customer Count
 * KPI information component
 */
const ARW2: ARW2Component = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Active Customer Count measures all customers who made a purchase (in-store or online) or enrolled in the Ace Rewards program within the previous 12 months.<br/><br/>
        This will not include any canceled Ace Rewards members or accounts flagged as a California Consumer Privacy Act opt-out.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        It is 6-7 times more expensive to acquire a new customer than it is to keep a current customer.<br/><br/>
        Ace Rewards communications are designed to strategically target your customers, delivering the right message at the right time.<br/><br/>
        These efforts have helped maintain a customer retention rate of 80%. On average, active customers visit your store 9 times a year and spend nearly $260.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        <ul>
          <li>Participate in 100% of the promotions offered on the Ace Rewards Promotions Grid to keep customers highly engaged and maintain strong member retention.</li>
          <li>Our goal is to consistently drive these customers back to your store, generating higher incremental sales and strengthening long-term loyalty.</li>
        </ul>
      </div>
    </div>
  );
};

ARW2.title = 'Active Customer Count - Ace Rewards';
ARW2.actionTitle = 'Active Customer Drilldown';
ARW2.actionHyperlink = 'dynamicURL:WFC:current';
export default ARW2;

